import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { Box } from "@mui/material";
import StatementPanel from "./StatementPanel";
import StatementTable from "./StatementTable";
import OutstandingTable from "./OutstandingTable";
import AgeingTable from "./AgeingTable";
import GroupStatementTable from "./GroupStatementTable";
import { useLocation } from "react-router-dom";

const Statements = () => {
  const [fromDate, setFromDate] = useState(null);
  const [soNumber, setSONumber] = useState(null);
  const [toDate, setToDate] = useState(null);
  const [value, setValue] = useState(0);
  const [statementDataMain, setStatementDataMain] = useState(null);
  const [outstandingStatementDataMain, setOutstandingStatementDataMain] =
    useState(null);
  const [ageingStatementDataMain, setAgeingStatementDataMain] = useState(null);
  const [showAccountStatement, setShowAccountStatement] = useState(false);
  const [showOutstandingStatement, setShowOutstandingStatement] =
    useState(false);
  const [showAgeingStatement, setShowAgeingStatement] = useState(false);
  const [isGroup, setIsGroup] = useState(false);
  const location = useLocation();
  const [initialAccountData, setInitialAccountData] = useState(null);

  useEffect(() => {
    console.log("IsGroup: in statement parent", isGroup);
    // console.log('setIsGroup: in statement parent',setIsGroup)
  }, [isGroup]);

  useEffect(() => {
    const soNo = location.state?.soNo;
    const accountCode = location.state?.accountCode;
    const accountName = location.state?.accountName;
    const accountBalance = location.state?.accountBalance;
    console.log("Account from navigation:", {
      accountCode,
      accountName,
      accountBalance,
    });
    if (accountCode) {
      setInitialAccountData({
        ACCOUNT: accountCode,
        DESCRIPTION: accountName,
        BALANCE: accountBalance,
      });
    }

    console.log("soNo:", soNo);
    setSONumber(soNo);
    if (soNo) {
      //
    }
  }, [location.state]);

  function CustomTabPanel(props) {
    const { children, value, index, ...other } = props;
    return (
      <div
        role="tabpanel"
        hidden={value !== index}
        id={`simple-tabpanel-${index}`}
        aria-labelledby={`simple-tab-${index}`}
        {...other}
      >
        {value === index && <Box sx={{ p: 3 }}>{children}</Box>}
      </div>
    );
  }

  CustomTabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.number.isRequired,
    value: PropTypes.number.isRequired,
  };

  const handleStatementsData = (data) => {
    setStatementDataMain(data);
    setShowAccountStatement(true);
    setShowOutstandingStatement(false);
    setShowAgeingStatement(false);
  };

  const handleOutstandingStatementsData = (data) => {
    setOutstandingStatementDataMain(data);
    setShowAccountStatement(false);
    setShowOutstandingStatement(true);
    setShowAgeingStatement(false);
  };

  const handleAgeingStatementsData = (data) => {
    setAgeingStatementDataMain(data);
    setShowAccountStatement(false);
    setShowOutstandingStatement(false);
    setShowAgeingStatement(true);
  };

  // SVG Graphic Component (Clean, modern dual-tone design)
const CustomerSearchIllustration = () => (
  <svg 
    width="120" 
    height="120" 
    viewBox="0 0 120 120" 
    fill="none" 
    xmlns="http://www.w3.org/2000/svg"
  >
    {/* Soft background circle */}
    <circle cx="60" cy="60" r="50" fill="#F3F4F6" />
    
    {/* User Card Silhouette */}
    <rect x="35" y="32" width="50" height="56" rx="8" fill="#FFFFFF" stroke="#E5E7EB" strokeWidth="2" />
    <circle cx="60" cy="50" r="10" fill="#CBD5E1" />
    <path d="M45 72C45 66.4772 49.4772 62 55 62H65C70.5228 62 75 66.4772 75 72V74H45V72Z" fill="#CBD5E1" />

    {/* Magnifying Glass Overlay */}
    <circle cx="72" cy="72" r="16" fill="#FFFFFF" stroke="#3B82F6" strokeWidth="3" />
    <path d="M84 84L94 94" stroke="#3B82F6" strokeWidth="3" strokeLinecap="round" />
    
    {/* Small search sparkle / detail */}
    <circle cx="68" cy="68" r="2" fill="#93C5FD" />
  </svg>
);

  // helper: render empty skeleton table
  const renderEmptyTable = () => (
    <div style={styles.container}>
      {/* Decorative SVG Graphic */}
      <div style={styles.iconContainer}>
        <CustomerSearchIllustration />
      </div>

      {/* Message */}
      <h3 style={styles.heading}>No Customer Selected</h3>
      <p style={styles.subtext}>
        Search for a customer or press F2 and pick one from the list to view their statement.
      </p>
    </div>
    
  );

  return (
    <div className="min-h-screen m-2">
      <h2 className="text-xl font-normal mb-4">Financial Statements</h2>
      <div className="flex justify-between items-start ">
        <div className="w-[400px] ml-2 bg-[#ECF6FE] shadow-md shadow-blue-400/50 rounded-lg py-4 pl-4 pr-6">
          <StatementPanel
            onStatementDataFetched={handleStatementsData}
            onOutstandingStatementDataFetched={handleOutstandingStatementsData}
            onAgeingStatementDataFetched={handleAgeingStatementsData}
            isGroup={isGroup}
            setIsGroup={setIsGroup}
            initialAccountData={initialAccountData}
          />
        </div>

        <div className="flex-1 overflow-x-auto mx-4">
          {showAccountStatement ? (
            statementDataMain && statementDataMain.length > 0 ? (
              isGroup ? (
                <GroupStatementTable tableData={statementDataMain} />
              ) : (
                <StatementTable tableData={statementDataMain} 
                initialAccountData={initialAccountData} />
              )
            ) : (
              renderEmptyTable()
            )
          ) : showOutstandingStatement ? (
            outstandingStatementDataMain &&
            outstandingStatementDataMain.length > 0 ? (
              <OutstandingTable tableData={outstandingStatementDataMain} />
            ) : (
              renderEmptyTable()
            )
          ) : showAgeingStatement ? (
            ageingStatementDataMain && ageingStatementDataMain.length > 0 ? (
              <AgeingTable tableData={ageingStatementDataMain} />
            ) : (
              renderEmptyTable()
            )
          ) : (
            renderEmptyTable()
          )}
        </div>
      </div>
    </div>
  );
};


// Styles
const styles = {
  container: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '48px 24px',
    textAlign: 'center',
    border: '2px dashed #E5E7EB',
    borderRadius: '16px',
    backgroundColor: '#FAFAFA',
    minHeight: '320px',
  },
  iconContainer: {
    marginBottom: '20px',
  },
  heading: {
    margin: '0 0 8px 0',
    fontSize: '18px',
    fontWeight: '600',
    color: '#1F2937', // Dark gray
  },
  subtext: {
    margin: 0,
    fontSize: '14px',
    color: '#6B7280', // Soft gray
    maxWidth: '340px',
    lineHeight: '1.5',
  },
};

export default Statements;
